import { patchUserProfile, UserProfile } from '@uplift/api';
import { EMPTY_STRING } from '@uplift/constants';
import { SettingsAddressFormType, settingsAddressValidation, SettingsAddressValidationRequiredMessages } from './SettingsAddressForm';
import { useWithAddressVerify } from '../../../../AddressVerification';
import { useUpdateSettingsHandlers } from '../hooks';
import { useL10n } from '@uplift/hooks';


export const useAddressForm = (userId: string, profile?: UserProfile, requiredMessages?: SettingsAddressValidationRequiredMessages) => {
  const l10n = useL10n();
  const { onFormSubmitSuccess, onFormSubmitError } = useUpdateSettingsHandlers(userId, l10n.providerSettings.homeAddress);
  const withAddressVerify = useWithAddressVerify();

  const addressFormik = () => {
    const initialValues: SettingsAddressFormType = {
      address1: profile?.address?.line1 || EMPTY_STRING,
      address2: profile?.address?.line2 || EMPTY_STRING,
      city: profile?.address?.city || EMPTY_STRING,
      state: profile?.address?.stateId || EMPTY_STRING,
      zip: profile?.address?.zip || EMPTY_STRING,
    };

    const validationSchema = settingsAddressValidation(l10n, requiredMessages);

    const onSubmit = withAddressVerify(async (values: SettingsAddressFormType) => {
      try {
        await patchUserProfile(userId, {
          address: {
            line1: values.address1,
            line2: values.address2 ?? '',
            city: values.city,
            stateId: values.state,
            zip: values.zip
          }
        });

        await onFormSubmitSuccess(true);
      } catch (error) {
        onFormSubmitError();
      }

      return { success: true };
    }, {
      shouldCheck: true,
      initialAddress: initialValues
    });

    return { initialValues, validationSchema, onSubmit };
  };

  return { addressFormik };
};
